import { Content } from 'helpers/content';
import { useState } from 'react';
// @ts-ignore
import { defaultStyles, FileIcon } from 'react-file-icon';

import { previewable } from './utils';

const ContentPreview = ({content, fallback}: {content: Content, fallback?: JSX.Element}) => {
  const [error, setError] = useState(false)
  const extension         = content.extension
  const style             = defaultStyles.hasOwnProperty(extension) ? defaultStyles[extension] : {}
  const defaultPreview    = fallback ? fallback : <FileIcon extension={extension} {...style} />

  if (!content.hasData || error || !previewable(content))
      return defaultPreview

  switch (true) {
    case content.type.startsWith("image/") :
      return (
        <img
          src={content.url}
          style={{ maxWidth: '100%', maxHeight: '100%', width: "100%", height: "100%", objectFit: 'scale-down' }} 
          onError={() => { console.error("Unable to load preview image for file: %o", content); setError(true) }}
        />
      )

    default:
      return defaultPreview
  }
}

export default ContentPreview